import { FC } from "react";
import FeatureItem from "./sub-components/FeatureItem";

export interface LotFeatureItemsProps {
    features: any[]
}

const LotFeatureItems: FC<LotFeatureItemsProps> = ({ features }) => {
    return <div className="pb-features">
        {
            features.map((feature, idx) => (
                <FeatureItem key={idx} feature={feature} idx={idx} />
            ))
        }
    </div>
};

export default LotFeatureItems;
